import React, { useState } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Icons
import { MdDelete } from "react-icons/md";
import { ImKey } from "react-icons/im";
import { TbEdit } from "react-icons/tb";

//Srcs
import "../../Style/actionstyle.scss";
import DeleteUser from "./DeleteUser";
import ResetPassword from "./ResetPassword";
import UserForm from "./UserForm";

export default function UserAction({ editData, setRefetch, userLogin }) {
  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  //Modal reset
  const [openReset, setOpenReset] = useState(false);
  const handleOpenReset = () => setOpenReset(true);
  const handleCloseReset = () => setOpenReset(false);

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        {/* <Tooltip title="កែប្រែពាក្យសម្ងាត់" placement="top">
          <IconButton onClick={handleOpenReset}>
            <Box className="reset-container">
              <ImKey className="reset-icon" />
            </Box>
          </IconButton>
        </Tooltip> */}
        <Tooltip title="កែប្រែ" placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <TbEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="លុប" placement="top">
          <IconButton
            onClick={handleOpenDel}
            disabled={userLogin?._id === editData?._id ? true : false}
          >
            <Box className="delete-container">
              <MdDelete
                className="delete-icon"
                sx={{
                  color:
                    userLogin?._id === editData?._id
                      ? "#bdbdbd !important"
                      : "red",
                }}
              />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <ResetPassword
        open={openReset}
        handleClose={handleCloseReset}
        editData={editData}
        setRefetch={setRefetch}
      />
      <UserForm
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
        dialogTitle="Update"
      />

      <DeleteUser
        open={openDel}
        handleClose={handleCloseDel}
        editData={editData}
        setRefetch={setRefetch}
      />
    </div>
  );
}
